export const orderTime = {
    methods:{
        //不考虑参数的影响
        getWorkTime(item){
          let time = 0;
          time += item.times*item.work_time_a + item.work_time_b;
          for(let param of item.params){
            if(param.type==='input'){
              time += parseInt(param.work_time_a)*parseInt(param.value?param.value:0);
            }else if(param.type==='select'){
              time += parseInt(param.work_time_a)*parseInt(param.value.value?param.value.priceValue:0);
            }else if(param.type==='multi'){
              for(let opt of param.options){
                if(opt.ifChoosed){
                  time += parseInt(param.work_time_a)*parseInt(opt.value);
                }
              }
    
            }
          }
          return time;
        },
        getPromiseTime(item){
          let time = 0;
          time += item.times*item.work_time_a + item.work_time_b + item.normal_promise_extra;
          for(let param of item.params){
            if(param.type==='input'){
              time += parseInt(param.promise_time_a)*parseInt(param.value?param.value:0);
            }else if(param.type==='select'){
              time += parseInt(param.promise_time_a)*parseInt(param.value.value?param.value.priceValue:0);
            }else if(param.type==='multi'){
              for(let opt of param.options){
                if(opt.ifChoosed){
                  time += parseInt(param.promise_time_a)*opt.value;
                }
              }
    
            }
          }
          return time;
        },
    }
}